var cbtUtil = require("../cbtUtil");

window.addEventListener("load", function () {
    var dataLayer = $("#contact-us-success-newsletter").data("cbt-contact-us-success");
    cbtUtil.dataPush(dataLayer);
});
